// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBIBfrqpNNI7Ed7yjnWo__F6dPpxPJf9co",
    authDomain: "gnpc-kerala.firebaseapp.com",
    projectId: "gnpc-kerala",
    storageBucket: "gnpc-kerala.appspot.com",
    messagingSenderId: "2236285355",
    appId: "1:2236285355:web:ce1fb3ffbeba08921712ee",
    measurementId: "G-77RH86WHZD"
  },
  // baseUrl: 'http://3.136.162.8:3000/'
  baseUrl: 'https://gnpc.club/api/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
